module.exports = __webpack_public_path__ + "static/img/badge-no-activity-active.afd3c63.svg";